var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label__link w-inline-block"},[(_vm.count)?_c('LKIconCount',{staticClass:"LKIconHistory__count",attrs:{"count":_vm.count}}):_vm._e(),_c('v-icon',{staticClass:"LKIconHistory__icon"},[_vm._v(" mdi-history ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }